import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stampa3d',
  templateUrl: './stampa3d.component.html',
  styleUrls: ['./stampa3d.component.scss'],
})
export class Stampa3dComponent implements OnInit {
  modulesText = {
    text: 'Il corso sfrutta la metodologia del learning by doing e sarà strutturato sulla base dell’età dei partecipanti. L’obiettivo è quello di migliorare le competenze tecniche dei ragazzi e lavorare sullo sviluppo di soft skill quali motivazione ad apprendere, partecipazione attiva e creatività.',
  };

  constructor() {}

  ngOnInit(): void {}
}
